import { BYTES_IN_MEGABYTE } from 'Constants/Global'

export const byteToMegabyte = (bite: number) => Math.floor(bite / BYTES_IN_MEGABYTE)

export const byteToKilobyte = (bite: number) => Math.floor(bite / 1024)
